export const brandName = "MAR360";
